// notifications.js
import { auth, messaging, analytics } from "./firebase";
import { getToken, onMessage } from "firebase/messaging";
import { signInAnonymously, getIdToken } from "firebase/auth";
import { logEvent } from "firebase/analytics";

let isInitialized = localStorage.getItem("fcm_initialized") === "true";
let currentUser = null;
let initializationInProgress = false;
const storedUserId = localStorage.getItem("fcm_userId");

console.log("Module initialization:", { isInitialized, storedUserId });

function checkAndRemoveStaleUser(currentId) {
  const storedId = localStorage.getItem("fcm_userId");
  if (storedId && storedId !== currentId) {
    localStorage.removeItem("fcm_userId");
    localStorage.removeItem("fcm_initialized");
    isInitialized = false;
    currentUser = null;
  }
}

if (storedUserId && auth.currentUser?.uid === storedUserId) {
  currentUser = auth.currentUser;
}

export const requestPermission = async () => {
  console.log("Starting requestPermission:", {
    isInitialized,
    currentUser: currentUser?.uid,
    storedUserId,
    authCurrentUser: auth.currentUser?.uid,
  });

  if (initializationInProgress) {
    console.log("Waiting for existing initialization...");
    await new Promise((resolve) => setTimeout(resolve, 1000));
    return {
      fcmToken: await getExistingFCMToken(),
      userId: currentUser?.uid,
    };
  }

  try {
    initializationInProgress = true;
    console.log("Starting new initialization");

    checkAndRemoveStaleUser(auth.currentUser?.uid);

    if (isInitialized && auth.currentUser) {
      currentUser = auth.currentUser;
      return {
        fcmToken: await getExistingFCMToken(),
        userId: currentUser.uid,
      };
    }

    if (!("Notification" in window) || !("serviceWorker" in navigator)) {
      throw new Error(
        "Browser does not support notifications or service workers"
      );
    }

    const permission = await Notification.requestPermission();
    if (permission !== "granted") {
      throw new Error("Notification permission denied");
    }

    const registration = await navigator.serviceWorker.register(
      "/firebase-messaging-sw.js"
    );
    await navigator.serviceWorker.ready;

    if (auth.currentUser) {
      currentUser = auth.currentUser;
      console.log("Using existing auth user:", currentUser.uid);
    } else {
      const userCredential = await signInAnonymously(auth);
      currentUser = userCredential.user;
      console.log("Anonymous auth result:", userCredential.user.uid);
    }

    const idToken = await getIdToken(currentUser, true);
    const vapidKey =
      "BLW_k5r-9kRI3lcFHoQZXhjUGJEcp1Mvgficuag3JyuS4H31ODAPzfHWocbY86nMXbEzHkvfQKnc6fT4EAkAfwM";

    const fcmToken = await getToken(messaging, {
      vapidKey: vapidKey.trim(),
      serviceWorkerRegistration: registration,
      headers: new Headers({
        Authorization: `Bearer ${idToken}`,
      }),
    });

    if (!fcmToken) {
      throw new Error("No FCM token received");
    }

    isInitialized = true;
    localStorage.setItem("fcm_initialized", "true");
    localStorage.setItem("fcm_userId", currentUser.uid);

    return {
      fcmToken,
      userId: currentUser.uid,
    };
  } catch (error) {
    console.error("Error in requestPermission:", error);
    isInitialized = false;
    localStorage.removeItem("fcm_initialized");
    throw error;
  } finally {
    initializationInProgress = false;
  }
};

const getExistingFCMToken = async () => {
  const vapidKey =
    "BLW_k5r-9kRI3lcFHoQZXhjUGJEcp1Mvgficuag3JyuS4H31ODAPzfHWocbY86nMXbEzHkvfQKnc6fT4EAkAfwM";
  return await getToken(messaging, { vapidKey: vapidKey.trim() });
};

export const onMessageListener = (callback) => {
  if (!messaging) {
    console.error("Messaging not initialized");
    return () => {}; // Return a no-op function to prevent errors
  }

  const unsubscribe = onMessage(messaging, (payload) => {
    console.log("Foreground notification received:", payload);

    // ✅ Log event to Firebase Analytics
    logEvent(analytics, "notification_open", {
      title: payload.notification?.title,
      body: payload.notification?.body,
    });

    callback(payload); // Pass the payload to the provided callback
  });

  return unsubscribe; // Return the unsubscribe function for cleanup
};
